import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "position", "onClose", "rootClassName", "className", "size", "container", "children", "hasBorderRadius", "swipeEnabled", "modalMode", "closeButtonEnabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import 'rc-drawer/assets/index.css';
import cn from 'classnames';
import RcDrawer from 'rc-drawer';
import { useEffect } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import { extractSupportProps } from '@snack-uikit/utils';
import { MODAL_MODE, POSITION, SIZE, SIZE_AS_VALUES } from '../../constants';
import { ButtonClose, DrawerBody, DrawerFooter, DrawerHeader } from '../../helperComponents';
import { DRAWER_CLOSING_TIMEOUT, motionProps } from './constants';
import { useSwipeProps } from './hooks';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MobileDrawerCustom(_ref) {
  var openProp = _ref.open,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? POSITION.Left : _ref$position,
    onClose = _ref.onClose,
    rootClassName = _ref.rootClassName,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE.S : _ref$size,
    container = _ref.container,
    children = _ref.children,
    _ref$hasBorderRadius = _ref.hasBorderRadius,
    hasBorderRadius = _ref$hasBorderRadius === void 0 ? false : _ref$hasBorderRadius,
    _ref$swipeEnabled = _ref.swipeEnabled,
    swipeEnabled = _ref$swipeEnabled === void 0 ? true : _ref$swipeEnabled,
    _ref$modalMode = _ref.modalMode,
    modalMode = _ref$modalMode === void 0 ? MODAL_MODE.Regular : _ref$modalMode,
    _ref$closeButtonEnabl = _ref.closeButtonEnabled,
    closeButtonEnabled = _ref$closeButtonEnabl === void 0 ? true : _ref$closeButtonEnabl,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isPredefinedSize = typeof size === 'string' && SIZE_AS_VALUES.includes(size);
  var _useUncontrolledProp = useUncontrolledProp(openProp, false),
    _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
    open = _useUncontrolledProp2[0],
    setOpen = _useUncontrolledProp2[1];
  var hasBlur = [MODAL_MODE.Forced, MODAL_MODE.Aggressive].includes(modalMode);
  var hasSwipe = [MODAL_MODE.Regular, MODAL_MODE.Aggressive].includes(modalMode);
  var handleClose = function handleClose() {
    setOpen(false);
    onClose();
  };
  var _useSwipeProps = useSwipeProps({
      position: position,
      onSwiped: handleClose,
      enabled: hasSwipe && swipeEnabled
    }),
    swipeRef = _useSwipeProps.swipeRef,
    drawerStyles = _useSwipeProps.drawerStyles,
    maskStyles = _useSwipeProps.maskStyles,
    drawerMotionProps = _useSwipeProps.drawerMotionProps,
    swipeProps = _useSwipeProps.swipeProps,
    showPointer = _useSwipeProps.showPointer;

  // Fix to prevent refresh when swiping on ios
  useEffect(function () {
    var hasOtherDrawers = function hasOtherDrawers() {
      return Boolean(document.querySelector('[data-content-wrapper]'));
    };
    var disableRefresh = function disableRefresh() {
      return document.documentElement.style.overscrollBehaviorY = 'none';
    };
    var enableRefresh = function enableRefresh() {
      return document.documentElement.style.overscrollBehaviorY = '';
    };
    if (open && !document.documentElement.style.overscrollBehaviorY) {
      disableRefresh();
      return function () {
        setTimeout(function () {
          return !hasOtherDrawers() && enableRefresh();
        }, DRAWER_CLOSING_TIMEOUT + 50);
      };
    }
  }, [open]);
  return /*#__PURE__*/_jsx(RcDrawer, _objectSpread(_objectSpread({
    mask: true,
    maskClosable: true,
    keyboard: true,
    maskClassName: cn(styles.mask, _defineProperty({}, styles.maskBlur, hasBlur)),
    width: !isPredefinedSize && (position === POSITION.Right || position === POSITION.Left) ? size : 'null',
    height: !isPredefinedSize && (position === POSITION.Top || position === POSITION.Bottom) ? size : 'null',
    open: open,
    placement: position,
    destroyOnClose: true,
    push: false,
    afterOpenChange: setOpen,
    onClose: modalMode === MODAL_MODE.Regular ? handleClose : undefined,
    getContainer: container,
    className: styles.drawer,
    rootClassName: cn(styles.drawerRoot, rootClassName, _defineProperty({}, styles.drawerBlur, hasBlur))
  }, extractSupportProps(rest)), {}, {
    "data-content-wrapper": true,
    "data-blur": hasBlur || undefined,
    "data-border-radius": hasBorderRadius || undefined,
    "data-size": isPredefinedSize ? size : undefined,
    "data-mode": "regular",
    "data-position": position,
    contentWrapperStyle: drawerStyles,
    maskStyle: maskStyles,
    motion: _objectSpread(_objectSpread({}, typeof motionProps.motion === 'function' ? motionProps.motion(position) : motionProps.motion), drawerMotionProps),
    maskMotion: motionProps.maskMotion,
    children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: cn(className, styles.content)
    }, swipeEnabled && hasSwipe ? swipeProps : undefined), {}, {
      ref: swipeRef,
      "data-swipe": swipeEnabled || undefined,
      "data-pointers": showPointer || undefined,
      children: [swipeEnabled && /*#__PURE__*/_jsx("div", {
        className: styles.swiper,
        "data-position": position
      }), children, closeButtonEnabled && /*#__PURE__*/_jsx("div", {
        className: styles.headerElements,
        children: /*#__PURE__*/_jsx(ButtonClose, {
          onClick: onClose
        })
      })]
    }))
  }));
}
(function (_MobileDrawerCustom) {
  var Header = _MobileDrawerCustom.Header = DrawerHeader;
  var Body = _MobileDrawerCustom.Body = DrawerBody;
  var Footer = _MobileDrawerCustom.Footer = DrawerFooter;
})(MobileDrawerCustom || (MobileDrawerCustom = {}));